import React, { useEffect, useRef, useState } from 'react';
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, message } from 'antd';
import { CloudSyncOutlined, FileAddOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import IndividualsRepository from '../../components/subject/IndividualsRepository'
import Alphabet from '../../components/alphabet/Alphabet';
import Search from '../../components/search/Search';
import FilterData from '../../components/filter/FilterData';
import { RdfTriplet, SubjectRepository} from '../../redux';
import { subsetByLangOrEmpty, getCountValue } from '../../virtuoso/helper';
import settings from '../../virtuoso/settings';
import { getValues } from '../../virtuoso/helper';
import { DetailLinkCard } from '../../components/adms/DetailLinkCard';

const showViewDetail = (selected, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("AssetList.js showViewDetail", selected);
	return <Modal style={{minWidth: "80%"}} open={true} 
    title="Детальная информация" 
    cancelText="Отмена" onCancel={onCancelOperation} 
    cancelButtonProps={{ disabled: true, dispaly: "none" }}
    okText="Ок" onOk={onFinishOperation}>
        <DetailLinkCard triplet={selected} factory={factory}/>
	  </Modal>
}


/** Добавить условие в список. Для словий с одной схемой формируется массив значений */
const includedConditions = (conditions, condition) => {
  //Проверим, что такая схема есть и тогда сделаем массив значений
  const scheme = conditions.filter(item => item.scheme == condition.scheme);
  if (scheme.length>0){
    if (!Array.isArray(scheme[0].value))
      scheme[0].value = [scheme[0].value];
    scheme[0].value.push(condition.value);
    return conditions;
  }
  return conditions.concat([condition])
}
/** Исключить условие из поиска */
const excludedConditions = (conditions, condition, taxonomy, lang) => {
  //console.log("AssetList.js excludedConditions", conditions, condition, taxonomy, lang);
  //Проверим, что такая схема есть и тогда исключим из массива значений значение condition
  const scheme = conditions.filter(item => item.scheme == condition.scheme);
  if (scheme.length>0){
    if (Array.isArray(scheme[0].value)){
        scheme[0].value = scheme[0].value.filter(item => item != condition.value)
        if (scheme[0].value.length == 1){
            scheme[0].value = scheme[0].value[0]
            //Надо обновить label, т.к. может он может не совпадать
            //label задаётся при добавлении условия, для массива label - первый заданный condition
            //см. отображение условий в FilterData.js
            //const schemes = taxonomy.filter(item => item.IRI && item.IRI.value && (item.IRI.value == condition.scheme));
            //const concepts = (schemes.length>0)?subsetByLangOrEmpty(schemes[0].concepts, lang, "IRI", "Label"):[];
            //const labels = concepts.filter(concept => concept.IRI.value == scheme[0].value);
            //scheme[0].label = (labels.length>0)?labels[0].Label.value:scheme[0].value;
        }
        return conditions;
    }
  }
  return conditions.filter(item => !((item.predicate==condition.predicate)&&(item.operator==condition.operator)&&(item.value==condition.value)));
}
/** Компонента для получения и отображения списка субъектов. 
 *  Доступные субъектоы фиксируются в vadms.
 * Линковка props и vadms происходит в containers.js
 */
class SubjectList extends React.Component {

    state = {
      modal: "none",		//Состояние модального окна. none - не показывается, detail - отобразить диалог c детальной информации об объекте
    };

    formRef = React.createRef();
  
  //Событие об изменение состава условий отбора
  // include - true - добавить условие, false - удалить условие.
  // condition - само условие. 
  // Если условия из одной схемы, то создать массив, который будет объединятся по ИЛИ
  onChangeListConditions (include, condition) {
    const {conditions, actions, taxonomy, lang, onChangeConditions} = this.props;
    let filter = conditions;
    if (Array.isArray(condition)){
      condition.forEach(item => 
        filter = (include)
          ? includedConditions(filter, item) 
          : excludedConditions(filter, item, taxonomy, lang)
      );
    } else {
      filter = (include)
        ? includedConditions(conditions, condition) 
        : excludedConditions(conditions, condition, taxonomy, lang);
    };
    if (onChangeConditions) 
      onChangeConditions(VocabsRepository, filter);
  };

    onSearchByAlphabet(include, char){
      const {onAlphabetSearch, conditions} = this.props;
      if (onAlphabetSearch) 
        onAlphabetSearch(VocabsRepository, (include)?char:"", conditions);      
    }

    onSearchByName (pattern) {
      //console.log("onSearchByName (pattern)", pattern, this);
      const {onNameSearch, conditions} = this.props;
      if (onNameSearch) 
        onNameSearch(VocabsRepository, pattern, conditions);
    }

    onRefresh (e) {
      e.preventDefault();
      const {conditions} = this.props;
      this.props.onRefreshList(VocabsRepository, conditions);
    };
    onNewVocab(e){
      e.preventDefault();
      this.setState({modal:"add"});
    };

    onLinkAssetDialog(e){
      e.preventDefault();
      this.setState({modal:"link"});
    };

    onShowCatalogInformation(e){
      e.preventDefault();
      this.setState({modal:"info"});
    }

  /** Слушатели различных действий */
  handlers(e, triplet, operation) {
    // //console.log("AssetList.js handlers", triplet, operation, this);
    // const {catalog} = this.props;
    // e.preventDefault();
    // if (operation== "detail" && this.props.onDetailElement) 
    //   this.props.onDetailElement(AdmsAsset, catalog.iri, triplet)
    //   .then (result =>{
    //     //console.log("AssetList.js handlers 2", result);
    //     this.setState({detail: triplet});
    // });
  };

  cancelOperation(){
    this.setState({modal:"none", detail: undefined});
  };

  /** Закрыть детальную информацию (возможно из карточки каталога) */
  cancelDetail(){
    this.setState({detail: undefined});
  };
    
  check(){

  };
  
  render() {
        console.log(this);
        const { modal, detail } = this.state;
        const {conditions, isSignedIn, inGroup, factory, lang, vselected} = this.props;
        //Условия отбора задаются в vadms см. AdmsActions с использованием действий добавления/удаления условия 
        const isCondition = (conditions && Array.isArray(conditions))?conditions.length>0: false;
        return (
            <div>
                <Row style={{display: "none"}}>
                    <Col className="csi_search_bar_title" span={6} style={{}}></Col>
                    <Col className="csi_search_form_div" span={18} style={{}}><Search onSearch={(value) => this.onSearchByName(value)} /></Col>
                </Row>
                <Row>
                    <Col className="csi_asset_list" span={24} style={{}}>
                        <Row style={{display: "none"}}><Alphabet selected={conditions} onChange={(i,c)=> this.onSearchByAlphabet(i,c)} /></Row>                            
                        <Row>
                          <Col span={22}>
                              <Tooltip placement="top" title={i18n.t('views.adms.list_reload_title')}>
                                  <Button icon={<CloudSyncOutlined />} onClick={(e)=> this.onRefresh(e)}></Button>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row id="IndividualsRepository" ><Col span={24}><IndividualsRepository {...this.props} /></Col></Row>
                    </Col>
                </Row>
                {detail && showViewDetail(detail, factory, ()=>this.cancelDetail(), ()=>this.cancelDetail())}
            </div>            
        )
    }
}

export default SubjectList;